import { Tooltip } from '@frontend/t7nd'
import { AvatarProps, Box, Typography } from '@mui/material'
import { ReactElement, cloneElement } from 'react'

export function AltImage(props: {
  src?: AvatarProps['src']
  icon?: ReactElement
  alt: string
  onClick: () => void
  size?: number
}) {
  const { src, alt, size = 40, onClick, icon } = props

  return (
    <Box position="relative">
      <Box
        sx={{
          width: '40px',
          height: '40px',
          borderRadius: '20px',
          border: '1px solid #E3E5EF',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        onClick={() => onClick()}
      >
        <Tooltip title={alt}>
          {icon ? (
            cloneElement(icon, {
              sx: {
                ...icon.props.sx,
                width: '20px',
                height: '20px',
                color: '#527BF2',
              },
            })
          ) : (
            <img
              src={src}
              alt={alt}
              style={{
                cursor: 'pointer',
                width: '20px',
                height: '20px',
              }}
            />
          )}
        </Tooltip>
      </Box>
    </Box>
  )
}
